import { cn } from '@/lib/utils';
import { HomeIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const SidebarMenuRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === '/';

    return (
        <>
            <div className="text-xs font-medium mb-2 text-sidebar-foreground/70 px-2">
                Menu Principal
            </div>
            <div className="w-full space-y-1">
                <div
                    onClick={() => navigate("/")}
                    className={cn(
                        "flex items-center gap-3 py-2 px-3 rounded-lg transition-all duration-200 cursor-pointer sidebar-menu-item",
                        "text-xs hover:bg-[#4B303C] hover:text-white border border-transparent hover:border-[#4B303C]",
                        isActive
                            ? "bg-[#4B303C] text-white border-[#4B303C] shadow-sm"
                            : "text-gray-700 hover:shadow-sm",
                    )}
                >
                    <span className="transition-all duration-200 flex-shrink-0">
                        <div className={cn(
                            isActive ? "[&>svg]:text-white" : "[&>svg]:text-gray-500"
                        )}>
                            <HomeIcon className="h-4 w-4" />
                        </div>
                    </span>
                    <span className="font-medium">Menu</span>
                </div>
            </div>
        </>
    );
};

export default SidebarMenuRoutes;
